import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

// Swap this URL freely — the loop logic doesn't depend on the source.
const VIDEO_URL =
  "https://d8j0ntlcm91z4.cloudfront.net/user_38xzZboKViGWJOttwIXH07lWA1P/hf_20260328_083109_283f3553-e28f-428b-a723-d639c617eb2b.mp4";

const FADE_DURATION = 0.5; // seconds for fade-in / fade-out

export default function CinematicHero() {
  const videoRef = useRef(null);
  const rafRef = useRef(null);
  const [opacity, setOpacity] = useState(0);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    let cancelled = false;

    const tick = () => {
      if (cancelled || !video) return;
      const duration = video.duration;
      const t = video.currentTime;

      if (Number.isFinite(duration) && duration > 0) {
        let nextOpacity = 1;
        if (t < FADE_DURATION) {
          nextOpacity = Math.max(0, t / FADE_DURATION);
        } else if (duration - t < FADE_DURATION) {
          nextOpacity = Math.max(0, (duration - t) / FADE_DURATION);
        }
        setOpacity(nextOpacity);
      }
      rafRef.current = requestAnimationFrame(tick);
    };

    const handleEnded = () => {
      setOpacity(0);
      window.setTimeout(() => {
        if (!videoRef.current) return;
        videoRef.current.currentTime = 0;
        const playPromise = videoRef.current.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      }, 100);
    };

    const handleLoaded = () => {
      const p = video.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
      rafRef.current = requestAnimationFrame(tick);
    };

    video.addEventListener("ended", handleEnded);
    video.addEventListener("loadedmetadata", handleLoaded);

    if (video.readyState >= 1) handleLoaded();

    return () => {
      cancelled = true;
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      video.removeEventListener("ended", handleEnded);
      video.removeEventListener("loadedmetadata", handleLoaded);
    };
  }, []);

  return (
    <section className="cinematic-hero">
      <div className="ch-video-wrap" aria-hidden="true">
        <video
          ref={videoRef}
          className="ch-video"
          src={VIDEO_URL}
          muted
          playsInline
          autoPlay
          preload="auto"
          style={{ opacity }}
        />
        <div className="ch-video-gradient" />
      </div>

      <div className="ch-content">
        <div className="ch-eyebrow">
          <span className="ch-eyebrow-dot" />
          <span>Web · AI · Ads · Growth</span>
        </div>

        <h1 className="ch-headline">
          Beyond <em>noise,</em>
          <br />
          we build <em>the lasting.</em>
        </h1>

        <p className="ch-sub">
          A digital growth studio where strategy, design, AI, and performance
          move as one signal — built for brands with something real to offer.
        </p>

        <div className="ch-actions">
          <Link to="/contact" className="ch-cta ch-cta-primary">
            Begin Journey
          </Link>
          <Link to="/work" className="ch-cta ch-cta-secondary">
            See the Work
          </Link>
        </div>
      </div>

      <div className="ch-scroll" aria-hidden="true">
        <span>Scroll</span>
        <span className="ch-scroll-line" />
      </div>
    </section>
  );
}
